import {Action} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {EntityRota} from './entity-rota.model';
import * as Actions from './entity-rota.actions';
import {ActionsExample, entityReducer, initial} from '~utils/ngrx-util';

export const entityRotasFeatureKey = 'entityRotas';

export interface StateRota extends EntityState<EntityRota> {
  loaded: boolean;
}

export const adapter: EntityAdapter<EntityRota> = createEntityAdapter<EntityRota>();

export const initialState: StateRota = adapter.getInitialState({initial, loaded: false});

const entityActions: ActionsExample<EntityRota> = {
  add: Actions.addEntityRota,
  adds: Actions.addEntityRotas,
  clear: Actions.clearEntityRotas,
  remove: Actions.deleteEntityRota,
  removes: Actions.deleteEntityRotas,
  load: Actions.loadEntityRotas,
  update: Actions.updateEntityRota,
  updates: Actions.updateEntityRotas,
  upsert: Actions.upsertEntityRota,
  upserts: Actions.upsertEntityRotas,
};

const entityRotaReducer = entityReducer(initialState, entityActions, adapter, {loaded: true}, {loaded: false});

export function reducer(state: StateRota | undefined, action: Action): StateRota {
  return entityRotaReducer(state, action);
}

export const {selectIds, selectEntities, selectAll, selectTotal} = adapter.getSelectors();


